import { Activity } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

export const formModels = {
	ANTRAG_F: "Antrag_F",
	FRIST_F: "Frist_F"
};
export const dataModels = {
	ANTRAG_D: "Antrag_D",
	FRIST_D: "Frist_D"
};
export const overviewModels = {
	FRISTEN_O: "Fristen_O"
};
export function prefix(resourceName: string, activity: Activity) {
	return `${activity.descriptor.fachverfahren}_${resourceName}`;
}
